import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserGuidesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserGuidesQuery = { __typename?: 'Query', getUserGuidesDocList?: Array<{ __typename?: 'UserGuidesDocList', groupName?: string | null, sortOrder?: number | null, groupSortOrder?: number | null, userGuideGroupId?: number | null, userGuideId?: number | null, userGuideName?: string | null, details?: Array<{ __typename?: 'UserGuideDetails', language?: string | null, userGuideBlob?: number | null }> | null }> | null };

export type DownloadUserGuideDocumentQueryVariables = Types.Exact<{
  blobId: Types.Scalars['Float']['input'];
}>;


export type DownloadUserGuideDocumentQuery = { __typename?: 'Query', downloadUserGuideDocument: { __typename?: 'UserGuideDocumentResponse', success?: string | null, value?: { __typename?: 'UserGuideValue', encodedFileData?: string | null, fileName?: string | null, mimeType?: string | null } | null } };

export type GetAllUserGuidesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllUserGuidesQuery = { __typename?: 'Query', getAllUserGuides: Array<{ __typename?: 'UserGuide', userGuideId?: number | null, userGuideNamePhraseId?: string | null, sortOrder?: number | null, insertUser?: string | null, insertDate?: string | null, updateUser?: string | null, updateDate?: string | null, userGuideGroup?: { __typename?: 'UserGuideGroup', userGuideGroupId?: number | null, userGuideGroupNamePhraseId?: string | null, sortOrder?: number | null } | null, translations?: Array<{ __typename?: 'TranslationResponse', languageCode?: string | null, phraseId?: string | null, translation?: string | null }> | null, userGuideBlobs?: Array<{ __typename?: 'UserGuideBlob', userGuideBlobId?: number | null, language?: string | null, blob?: { __typename?: 'TFBlobResponse', blobId?: number | null, downloadLink?: string | null, fileName?: string | null, mimeType?: string | null } | null }> | null }> };

export type GetUserGuideQueryVariables = Types.Exact<{
  id: Types.Scalars['Float']['input'];
}>;


export type GetUserGuideQuery = { __typename?: 'Query', getUserGuide?: { __typename?: 'UserGuide', userGuideId?: number | null, userGuideNamePhraseId?: string | null, sortOrder?: number | null, insertUser?: string | null, insertDate?: string | null, updateUser?: string | null, updateDate?: string | null, userGuideGroup?: { __typename?: 'UserGuideGroup', userGuideGroupId?: number | null, userGuideGroupNamePhraseId?: string | null, sortOrder?: number | null } | null, translations?: Array<{ __typename?: 'TranslationResponse', languageCode?: string | null, phraseId?: string | null, translation?: string | null }> | null, userGuideBlobs?: Array<{ __typename?: 'UserGuideBlob', userGuideBlobId?: number | null, language?: string | null, blob?: { __typename?: 'TFBlobResponse', blobId?: number | null, downloadLink?: string | null, fileName?: string | null, mimeType?: string | null } | null }> | null } | null };

export type GetAllUserGuideGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllUserGuideGroupsQuery = { __typename?: 'Query', getAllUserGuideGroups: Array<{ __typename?: 'UserGuideGroup', userGuideGroupId?: number | null, userGuideGroupNamePhraseId?: string | null, sortOrder?: number | null, insertUser?: string | null, insertDate?: string | null, updateUser?: string | null, updateDate?: string | null, translations?: Array<{ __typename?: 'TranslationResponse', languageCode?: string | null, phraseId?: string | null, translation?: string | null }> | null }> };

export type GetUserGuideUploadLanguagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserGuideUploadLanguagesQuery = { __typename?: 'Query', getUserGuideUploadLanguages?: { __typename?: 'UserGuideLanguages', languages: Array<string> } | null };


export const GetUserGuidesDocument = gql`
    query getUserGuides {
  getUserGuidesDocList {
    groupName
    sortOrder
    groupSortOrder
    userGuideGroupId
    userGuideId
    userGuideName
    details {
      language
      userGuideBlob
    }
  }
}
    `;

/**
 * __useGetUserGuidesQuery__
 *
 * To run a query within a React component, call `useGetUserGuidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGuidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGuidesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserGuidesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserGuidesQuery, GetUserGuidesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserGuidesQuery, GetUserGuidesQueryVariables>(GetUserGuidesDocument, options);
      }
export function useGetUserGuidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserGuidesQuery, GetUserGuidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserGuidesQuery, GetUserGuidesQueryVariables>(GetUserGuidesDocument, options);
        }
// @ts-ignore
export function useGetUserGuidesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserGuidesQuery, GetUserGuidesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserGuidesQuery, GetUserGuidesQueryVariables>;
export function useGetUserGuidesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserGuidesQuery, GetUserGuidesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserGuidesQuery | undefined, GetUserGuidesQueryVariables>;
export function useGetUserGuidesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserGuidesQuery, GetUserGuidesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserGuidesQuery, GetUserGuidesQueryVariables>(GetUserGuidesDocument, options);
        }
export type GetUserGuidesQueryHookResult = ReturnType<typeof useGetUserGuidesQuery>;
export type GetUserGuidesLazyQueryHookResult = ReturnType<typeof useGetUserGuidesLazyQuery>;
export type GetUserGuidesSuspenseQueryHookResult = ReturnType<typeof useGetUserGuidesSuspenseQuery>;
export type GetUserGuidesQueryResult = Apollo.QueryResult<GetUserGuidesQuery, GetUserGuidesQueryVariables>;
export const DownloadUserGuideDocumentDocument = gql`
    query downloadUserGuideDocument($blobId: Float!) {
  downloadUserGuideDocument(blobId: $blobId) {
    success
    value {
      encodedFileData
      fileName
      mimeType
    }
  }
}
    `;

/**
 * __useDownloadUserGuideDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadUserGuideDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadUserGuideDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadUserGuideDocumentQuery({
 *   variables: {
 *      blobId: // value for 'blobId'
 *   },
 * });
 */
export function useDownloadUserGuideDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadUserGuideDocumentQuery, DownloadUserGuideDocumentQueryVariables> & ({ variables: DownloadUserGuideDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadUserGuideDocumentQuery, DownloadUserGuideDocumentQueryVariables>(DownloadUserGuideDocumentDocument, options);
      }
export function useDownloadUserGuideDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadUserGuideDocumentQuery, DownloadUserGuideDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadUserGuideDocumentQuery, DownloadUserGuideDocumentQueryVariables>(DownloadUserGuideDocumentDocument, options);
        }
// @ts-ignore
export function useDownloadUserGuideDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadUserGuideDocumentQuery, DownloadUserGuideDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadUserGuideDocumentQuery, DownloadUserGuideDocumentQueryVariables>;
export function useDownloadUserGuideDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadUserGuideDocumentQuery, DownloadUserGuideDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadUserGuideDocumentQuery | undefined, DownloadUserGuideDocumentQueryVariables>;
export function useDownloadUserGuideDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadUserGuideDocumentQuery, DownloadUserGuideDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadUserGuideDocumentQuery, DownloadUserGuideDocumentQueryVariables>(DownloadUserGuideDocumentDocument, options);
        }
export type DownloadUserGuideDocumentQueryHookResult = ReturnType<typeof useDownloadUserGuideDocumentQuery>;
export type DownloadUserGuideDocumentLazyQueryHookResult = ReturnType<typeof useDownloadUserGuideDocumentLazyQuery>;
export type DownloadUserGuideDocumentSuspenseQueryHookResult = ReturnType<typeof useDownloadUserGuideDocumentSuspenseQuery>;
export type DownloadUserGuideDocumentQueryResult = Apollo.QueryResult<DownloadUserGuideDocumentQuery, DownloadUserGuideDocumentQueryVariables>;
export const GetAllUserGuidesDocument = gql`
    query GetAllUserGuides {
  getAllUserGuides {
    userGuideId
    userGuideNamePhraseId
    sortOrder
    insertUser
    insertDate
    updateUser
    updateDate
    userGuideGroup {
      userGuideGroupId
      userGuideGroupNamePhraseId
      sortOrder
    }
    translations {
      languageCode
      phraseId
      translation
    }
    userGuideBlobs {
      userGuideBlobId
      language
      blob {
        blobId
        downloadLink
        fileName
        mimeType
      }
    }
  }
}
    `;

/**
 * __useGetAllUserGuidesQuery__
 *
 * To run a query within a React component, call `useGetAllUserGuidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUserGuidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUserGuidesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUserGuidesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUserGuidesQuery, GetAllUserGuidesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUserGuidesQuery, GetAllUserGuidesQueryVariables>(GetAllUserGuidesDocument, options);
      }
export function useGetAllUserGuidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUserGuidesQuery, GetAllUserGuidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUserGuidesQuery, GetAllUserGuidesQueryVariables>(GetAllUserGuidesDocument, options);
        }
// @ts-ignore
export function useGetAllUserGuidesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllUserGuidesQuery, GetAllUserGuidesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllUserGuidesQuery, GetAllUserGuidesQueryVariables>;
export function useGetAllUserGuidesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUserGuidesQuery, GetAllUserGuidesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllUserGuidesQuery | undefined, GetAllUserGuidesQueryVariables>;
export function useGetAllUserGuidesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUserGuidesQuery, GetAllUserGuidesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllUserGuidesQuery, GetAllUserGuidesQueryVariables>(GetAllUserGuidesDocument, options);
        }
export type GetAllUserGuidesQueryHookResult = ReturnType<typeof useGetAllUserGuidesQuery>;
export type GetAllUserGuidesLazyQueryHookResult = ReturnType<typeof useGetAllUserGuidesLazyQuery>;
export type GetAllUserGuidesSuspenseQueryHookResult = ReturnType<typeof useGetAllUserGuidesSuspenseQuery>;
export type GetAllUserGuidesQueryResult = Apollo.QueryResult<GetAllUserGuidesQuery, GetAllUserGuidesQueryVariables>;
export const GetUserGuideDocument = gql`
    query GetUserGuide($id: Float!) {
  getUserGuide(id: $id) {
    userGuideId
    userGuideNamePhraseId
    sortOrder
    insertUser
    insertDate
    updateUser
    updateDate
    userGuideGroup {
      userGuideGroupId
      userGuideGroupNamePhraseId
      sortOrder
    }
    translations {
      languageCode
      phraseId
      translation
    }
    userGuideBlobs {
      userGuideBlobId
      language
      blob {
        blobId
        downloadLink
        fileName
        mimeType
      }
    }
  }
}
    `;

/**
 * __useGetUserGuideQuery__
 *
 * To run a query within a React component, call `useGetUserGuideQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGuideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGuideQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserGuideQuery(baseOptions: Apollo.QueryHookOptions<GetUserGuideQuery, GetUserGuideQueryVariables> & ({ variables: GetUserGuideQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserGuideQuery, GetUserGuideQueryVariables>(GetUserGuideDocument, options);
      }
export function useGetUserGuideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserGuideQuery, GetUserGuideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserGuideQuery, GetUserGuideQueryVariables>(GetUserGuideDocument, options);
        }
// @ts-ignore
export function useGetUserGuideSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserGuideQuery, GetUserGuideQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserGuideQuery, GetUserGuideQueryVariables>;
export function useGetUserGuideSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserGuideQuery, GetUserGuideQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserGuideQuery | undefined, GetUserGuideQueryVariables>;
export function useGetUserGuideSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserGuideQuery, GetUserGuideQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserGuideQuery, GetUserGuideQueryVariables>(GetUserGuideDocument, options);
        }
export type GetUserGuideQueryHookResult = ReturnType<typeof useGetUserGuideQuery>;
export type GetUserGuideLazyQueryHookResult = ReturnType<typeof useGetUserGuideLazyQuery>;
export type GetUserGuideSuspenseQueryHookResult = ReturnType<typeof useGetUserGuideSuspenseQuery>;
export type GetUserGuideQueryResult = Apollo.QueryResult<GetUserGuideQuery, GetUserGuideQueryVariables>;
export const GetAllUserGuideGroupsDocument = gql`
    query GetAllUserGuideGroups {
  getAllUserGuideGroups {
    userGuideGroupId
    userGuideGroupNamePhraseId
    sortOrder
    insertUser
    insertDate
    updateUser
    updateDate
    translations {
      languageCode
      phraseId
      translation
    }
  }
}
    `;

/**
 * __useGetAllUserGuideGroupsQuery__
 *
 * To run a query within a React component, call `useGetAllUserGuideGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUserGuideGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUserGuideGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUserGuideGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUserGuideGroupsQuery, GetAllUserGuideGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUserGuideGroupsQuery, GetAllUserGuideGroupsQueryVariables>(GetAllUserGuideGroupsDocument, options);
      }
export function useGetAllUserGuideGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUserGuideGroupsQuery, GetAllUserGuideGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUserGuideGroupsQuery, GetAllUserGuideGroupsQueryVariables>(GetAllUserGuideGroupsDocument, options);
        }
// @ts-ignore
export function useGetAllUserGuideGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllUserGuideGroupsQuery, GetAllUserGuideGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllUserGuideGroupsQuery, GetAllUserGuideGroupsQueryVariables>;
export function useGetAllUserGuideGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUserGuideGroupsQuery, GetAllUserGuideGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllUserGuideGroupsQuery | undefined, GetAllUserGuideGroupsQueryVariables>;
export function useGetAllUserGuideGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUserGuideGroupsQuery, GetAllUserGuideGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllUserGuideGroupsQuery, GetAllUserGuideGroupsQueryVariables>(GetAllUserGuideGroupsDocument, options);
        }
export type GetAllUserGuideGroupsQueryHookResult = ReturnType<typeof useGetAllUserGuideGroupsQuery>;
export type GetAllUserGuideGroupsLazyQueryHookResult = ReturnType<typeof useGetAllUserGuideGroupsLazyQuery>;
export type GetAllUserGuideGroupsSuspenseQueryHookResult = ReturnType<typeof useGetAllUserGuideGroupsSuspenseQuery>;
export type GetAllUserGuideGroupsQueryResult = Apollo.QueryResult<GetAllUserGuideGroupsQuery, GetAllUserGuideGroupsQueryVariables>;
export const GetUserGuideUploadLanguagesDocument = gql`
    query getUserGuideUploadLanguages {
  getUserGuideUploadLanguages {
    languages
  }
}
    `;

/**
 * __useGetUserGuideUploadLanguagesQuery__
 *
 * To run a query within a React component, call `useGetUserGuideUploadLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGuideUploadLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGuideUploadLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserGuideUploadLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserGuideUploadLanguagesQuery, GetUserGuideUploadLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserGuideUploadLanguagesQuery, GetUserGuideUploadLanguagesQueryVariables>(GetUserGuideUploadLanguagesDocument, options);
      }
export function useGetUserGuideUploadLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserGuideUploadLanguagesQuery, GetUserGuideUploadLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserGuideUploadLanguagesQuery, GetUserGuideUploadLanguagesQueryVariables>(GetUserGuideUploadLanguagesDocument, options);
        }
// @ts-ignore
export function useGetUserGuideUploadLanguagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserGuideUploadLanguagesQuery, GetUserGuideUploadLanguagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserGuideUploadLanguagesQuery, GetUserGuideUploadLanguagesQueryVariables>;
export function useGetUserGuideUploadLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserGuideUploadLanguagesQuery, GetUserGuideUploadLanguagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserGuideUploadLanguagesQuery | undefined, GetUserGuideUploadLanguagesQueryVariables>;
export function useGetUserGuideUploadLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserGuideUploadLanguagesQuery, GetUserGuideUploadLanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserGuideUploadLanguagesQuery, GetUserGuideUploadLanguagesQueryVariables>(GetUserGuideUploadLanguagesDocument, options);
        }
export type GetUserGuideUploadLanguagesQueryHookResult = ReturnType<typeof useGetUserGuideUploadLanguagesQuery>;
export type GetUserGuideUploadLanguagesLazyQueryHookResult = ReturnType<typeof useGetUserGuideUploadLanguagesLazyQuery>;
export type GetUserGuideUploadLanguagesSuspenseQueryHookResult = ReturnType<typeof useGetUserGuideUploadLanguagesSuspenseQuery>;
export type GetUserGuideUploadLanguagesQueryResult = Apollo.QueryResult<GetUserGuideUploadLanguagesQuery, GetUserGuideUploadLanguagesQueryVariables>;